export function bannerForms() {
	const banners = document.querySelectorAll('.section--banner:has(.property-form-wrapper):has(.property-form-container)')

	if (banners) {
		banners.forEach((b) => {
			const sliderStyle = window.getComputedStyle(b.querySelector('.splide'))
			const form = b.querySelector('.property-form-wrapper')
			const formPlaceholders = b.querySelectorAll('.property-form-placeholder')

			form.style.marginBottom = sliderStyle.paddingBottom

			const setSize = () => {
				const offsetHeight = form.offsetHeight
				formPlaceholders.forEach((fP) => {
					fP.style.minHeight = offsetHeight + 'px'
				})
			}

			setSize()

			// Verwenden Sie einen ResizeObserver anstelle des resize-Events
			const resizeObserver = new ResizeObserver((entries) => {
				for (let entry of entries) {
					if (entry.target === form) {
						setSize()
					}
				}
			})

			resizeObserver.observe(form)
		})
	}
}
